// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"95ddcfd9","453":"9eb00ecb","988":"485ccc71"}[chunkId] + ".chunk.js";
};